<template>
<div class="popup" v-if="isShow">
    <div class="content vip_to_unlimit_popup">
        <!-- 标题 -->
        <div class="popup_title">
            <div class="popup_title_bg"></div>
            <div class="popup_title_content">
                <div class="popup_title_main">{{ title }}</div>
                <div class="popup_title_sub">{{ desc }}</div>
                <div class="popup_title_close" @click="isShow=!isShow"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="popup_content">
            <paySchemeTab ref="payScheme" v-for="(allowScheme,index) in allowSchemes" :key="index" :payScheme=allowScheme :index=index isVIP="true" data-popup :data-last="index==allowSchemes.length-1?'Y':'N'"></paySchemeTab>
        </div>
    </div>
</div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
import paySchemeTab from '@/components/common/tabs/tabs_pay_system/tab_pay_scheme';
export default {
    name: "upgradeVipDialog",
    components: {
        paySchemeTab,
    },
    computed: {
        allowSchemes() {
            var list = [];
            var paySysRes = this.$store.getters.getPaySysRes;
            var nowSchemeId = paySysRes.nowScheme.id;
            paySysRes.vipSchemes.forEach(function (item) {
                if (item.level == 1) {
                    if (item.id != nowSchemeId) {
                        list.push(item);
                    }
                }
            });
            return list;
        },
    },
    data: function () {
        return {
            // 是否显示弹窗
            isShow: false,
            // 主标题
            title: this.$t('language.paySystem.supportItem.vipPopupTitleTraffic'),
            // 描述
            desc: this.$t('language.paySystem.supportItem.vipPopupDescTraffic'),
        }
    },
    watch: {
        isShow(newVal) {
            if (newVal) {
                this.ga();
            }
        },
    },
    methods: {
        // 点击升级按钮
        upgradePlan(item) {
            var that = this.$parent;
            while (that && that.$el.className!='work-space') {
                that = that.$parent;
            }
            if (that && that.$el.className=='work-space') {
                that.$refs.paySys.upgradePlan(item);
                this.isShow = false;
            }
        },
        // GA
        ga() {
            // 弹窗标题类型
            var isInsPopup = (this.title == this.$t('language.paySystem.supportItem.vipPopupTitleIns'));
            var isTrafficPopup = (this.title == this.$t('language.paySystem.supportItem.vipPopupTitleTraffic'));
            // 用于页面判断
            var routePath = this.$route.path;
            var isInsPage = (routePath == '/mc_project/image_saver_ins');
            var isWebPage = (routePath == '/mc_project/image_saver_web');
            var isTaskPage = (routePath == '/mc_project/image_saver_task');
            var isVideoPage = (routePath == '/mc_project/video_saver');
            var isVideoTaskPage = (routePath == '/mc_project/video_saver_task');
            var isInsTaskList = this.$store.state.isInsTaskList;
            // Ins GA
            if (isInsPage || (isTaskPage&&isInsTaskList)) {
                if (isInsPopup) {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'ins_vip_popup_inscount'});
                }
                if (isTrafficPopup) {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'ins_vip_popup_traffic'});
                }
            }
            // Web GA
            if (isWebPage || (isTaskPage&&!isInsTaskList)) {
                if (isTrafficPopup) {
                    taskListUtils.imageSaverRequest("/ga", {gaType:'web_vip_popup_traffic'});
                }
            }
            // Video GA
            if (isVideoPage || isVideoTaskPage) {
                if (isTrafficPopup) {
                    this.$multcloudGA('video_vip_popup_traffic');
                }
            }
        },
    },
}
</script>

<style scoped>
/* 小屏小弹窗 */
@media (max-width: 1920px) {
    .vip_to_unlimit_popup {
        transform: scale(0.8);
    }
}
/* 外框 */
.content {
    width: 1000px;
    height: 608px;
    border: none;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0px 10px 10px 0px rgba(87, 94, 136, 0.3);
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    overflow: hidden;
}
/* 标题框 */
.popup_title {
    height: 169px;
    position: relative;
}
/* 标题背景 */
.popup_title_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    background-color: #3F4A8D;
    background-image: url("../../../assets/images/imageSaver/upgradePopupBg.png");
    background-blend-mode: overlay;
    background-position: -1px -250px;
    background-size: 1002px 900px;
}
/* 标题内容 */
.popup_title_content {
    width: 100%;
    height: 100%;
    text-align: center;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}
/* 主标题 */
.popup_title_main {
    margin-top: 56.5px;
    height: 32px;
    line-height: 32px;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
}
/* 副标题 */
.popup_title_sub {
    margin-top: 10px;
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    font-weight: normal;
    color: #FFFFFF;
}
/* 关闭 */
.popup_title_close {
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 1;
    right: 10px;
    top: 10px;
    background-image: url("../../../assets/images/imageSaver/upgradeClose.svg");
    cursor: pointer;
}
.popup_title_close:hover {
    background-image: url("../../../assets/images/imageSaver/upgradeCloseHover.svg");
}
.popup_title_close:active {
    background-image: url("../../../assets/images/imageSaver/upgradeCloseActive.svg");
}
/* 主要内容 */
.popup_content {
    position: relative;
}
/* 内容外框 */
.popup_content>div {
    width: 450px;
    height: 360px;
    position: absolute;
    top: 40px;
    box-sizing: border-box;
    border-radius: 12px;
}
/* 覆盖付费套餐样式 */
.pay_scheme_body[data-popup][data-index] {
    box-shadow: none;
    margin-left: 0px;
    height: auto;
}
.pay_scheme_body[data-popup][data-index='0'] {
    left: 40px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: linear-gradient(180deg, #FFFFFF 49%, #FFF9F5 100%);
}
.pay_scheme_body[data-popup][data-index='1'] {
    right: 40px;
    border: 1px solid rgba(255, 108, 25, 0.5);
    background: linear-gradient(180deg, #FFF2EB 0%, #FFFFFF 53%), #FFFFFF;
}
.pay_scheme_body[data-popup][data-index='0'][data-last=Y] {
    left: 270px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/upgrade_account_vip_popup.vue